import React from 'react';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDText
} from '@jdreact/jdreact-core-lib';

import { moneyHandle, pt, px } from '../../common/utils';

import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import { setLog } from '../../common/log';

export default (props) => {
    const {
        price,
        onlinePayFee,
        count,
        jdbeans,
        coupon,
        scaleFee,
        selectCertInfo,
        selectCertInfoDetails, // 兑换券详情
        cardUseNum,
        paySeatPrice,
        yingdouCount,
        seatsGroup,
        partition,
        promoInfo,
        selectCertificateMap,
        promoDiscountPrice, // 单张优惠金额
		    promoSeatCount,
		    moveidCardFee
    } = props;
		// 进行数据处理 [开启分区就显示不同票价];
		const isShowNewDetail =  (+partition === 1)
		// 根据价格把数组进行拆分, 从低到高进行排序
		const newArr = {};
		// 优惠总金额
		let exchangeAmount = 0;
		// 开启了分区
		if (isShowNewDetail) {
				setLog().name('分区明细').add(selectCertificateMap)
				const priceList = []
				seatsGroup.map(value=> priceList.push(value?.originalPrice))
				priceList.sort();
				const newPrice = [...new Set(priceList)];
				newPrice.map(value => newArr[value] = []);
				seatsGroup.map(value => {
						const data = newPrice.filter(val=> val === value?.originalPrice)
						if (data.length) {
								newArr[data[0]].push(value);
						}
				});
				for (let x in selectCertificateMap) {
						selectCertificateMap[x].map(item => exchangeAmount += item?.price)
				}
		} else {
				exchangeAmount = moveidCardFee
		}
		console.log('exchangeAmount', exchangeAmount)
    return (
        <View style={ st.info }>
            <View style={ st.top }>
                {
                    // 开启了分区并且有优惠
                    isShowNewDetail
                        ?  <View>
                            <View style={ st.item }>
                                <JDText style={ st.title }>费用明细</JDText>
                            </View>
                            {
                                Object.keys(newArr).map((value, index) => {
                                    const itemValue = newArr[value];
                                    const money = moneyHandle(value);
                                    return (
                                        <>
                                            <View style={ st.item } key={index}>
                                                <JDText style={ st.i_text }>票价</JDText>
                                                <View style={ st.item_right }>
                                                    <JDText style={ st.i_price }>&yen;{ money }</JDText>
                                                    <JDText style={ [st.i_text, st.min] }>X{itemValue.length}</JDText>
                                                </View>
                                            </View>
                                        </>
                                    )
                                })
                            }
                        </View>
                        : <>
                            <View style={ st.item }>
                                <JDText style={ st.title }>费用明细</JDText>
                            </View>
                            <View style={ st.item }>
                                <JDText style={ st.i_text }>票价</JDText>
                                <View style={ st.item_right }>
                                    <JDText style={ st.i_price }>&yen;{parseFloat(price)}</JDText>
                                    <JDText style={ [st.i_text, st.min] }>X{count}</JDText>
                                </View>
                            </View>
                        </>
                }
                
                {
                    scaleFee > 0 &&
                        <View style={ st.item }>
                            <JDText style={ st.i_text }>促销优惠</JDText>
                            <JDText style={ st.i_price }>-&yen;{scaleFee}</JDText>
                        </View>
                }

                {
                    jdbeans > 0 &&
                        <View style={ st.item }>
                            <JDText style={ st.i_text }>京豆抵扣</JDText>
                            <JDText style={ st.i_price }>-&yen;{parseFloat(jdbeans)}</JDText>
                        </View>
                }

                {
                    coupon > 0 &&
                        <View style={ st.item }>
                            <JDText style={ st.i_text }>京东优惠券</JDText>
                            <JDText style={ st.i_price }>-&yen;{coupon}</JDText>
                        </View>
                }

                {
                    selectCertInfo &&
                        <View style={ st.item }>
                            <JDText style={ st.i_text }>电影兑换券</JDText>
                            <View style={ st.item_right }>
                                <JDText style={ st.i_price }>-&yen;{moneyHandle(exchangeAmount)}</JDText>
                            </View>
                        </View>
                }
                {
                    yingdouCount
                        ? (
                            <View style={ st.item }>
                                <JDText style={ st.i_text }>影豆抵扣</JDText>
                                <View style={ st.item_right }>
                                    <JDText style={ st.i_price }>-&yen;{parseFloat(yingdouCount)}</JDText>
                                </View>
                            </View>
                        )
                        : null
                }
            </View>
            <LinearGradient colors={ ['rgba(255,255,255,0)', '#f7f7f7'] } style={ st.linear } />
            <View style={ [st.item, st.border_top] }>
                <JDText style={ st.i_text_line }>实付款</JDText>
                <JDText style={ [st.i_price, st.price_big] }>&yen;{onlinePayFee}</JDText>
            </View>
        </View>
    );
};

const st = StyleSheet.create({
    info: {
        backgroundColor: '#fff',
        borderBottomColor: 'rgba(0,0,0,.1)',
        borderBottomWidth: px(1),
        paddingTop: pt(10)
    },
    top: {
        paddingHorizontal: pt(16)
    },
    item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: pt(8),
        alignItems: 'center',
        height: pt(40)
    },
    item_right: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    title: {
        fontSize: pt(18)
    },
    i_text: {
        fontSize: pt(14),
        color: 'rgb(37,37,37)',
        alignSelf: 'flex-end'
    },
    i_text_line: {
        fontSize: pt(14),
        color: 'rgb(37,37,37)',
        alignSelf: 'center'
    },
    min: {
        fontSize: pt(12),
        marginBottom: pt(1)
    },
    i_price: {
        fontSize: pt(14),
        // color: 'rgb(37,37,37)'
        color: '#E2231A',
        flexDirection: 'row'
    },
    price_big: {
        fontSize: pt(20),
        fontWeight: 'bold',
        color: '#E2231A'
    },
    border_top: {
        // borderTopColor: 'rgba(0,0,0,.1)',
        // borderTopWidth: px(1),
        paddingHorizontal: pt(16),
        alignItems: 'center',
        marginTop: pt(5),
        height: pt(50)
    },

    linear: {
        width: pt(375),
        height: pt(10)
    }
});
